<div class="valueBadges" role="group" aria-label="Поисковые ключи">
  <span class="valueBadge" *ngFor="let row of product?.searchKeys">
    <span class="valueBadgeText">{{ row.key }}</span>
    <button
      type="button"
      class="valueBadgeRemove"
      [attr.aria-label]="'Удалить ключ ' + row.key"
      matTooltip="Удалить ключ"
      [disabled]="isLoading(row.key)"
      (click)="removeKey(row.key)"
    >
      <mat-icon>close</mat-icon>
    </button>
  </span>
  <button
    type="button"
    class="valueBadgeAdd"
    aria-label="Добавить поисковый ключ"
    (click)="openDialog()"
  >
    <mat-icon>add</mat-icon>Добавить
  </button>
</div>
